import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `nginx`,

  name: {
    [LOCALES.EN_US]: `Nginx`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.runtime_environment, TYPES.tool],

  tags: [],
} as const satisfies TTerm
